const WellNowVirtualCare = (props: { fill: string }) => (
	<>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M11.2576 4.28158C9.76424 4.28158 8.55361 5.4922 8.55361 6.98558V25.5136C8.55361 27.007 9.76424 28.2176 11.2576 28.2176H20.9472C22.4406 28.2176 23.6512 27.007 23.6512 25.5136V6.98558C23.6512 5.4922 22.4406 4.28158 20.9472 4.28158H11.2576ZM6.95361 6.98558C6.95361 4.60855 8.88058 2.68158 11.2576 2.68158H20.9472C23.3242 2.68158 25.2512 4.60855 25.2512 6.98558V25.5136C25.2512 27.8906 23.3242 29.8176 20.9472 29.8176H11.2576C8.88058 29.8176 6.95361 27.8906 6.95361 25.5136V6.98558Z"
			fill={props.fill}
		/>
		<path
			d="M16.1024 26.1248C16.8588 26.1248 17.472 25.5116 17.472 24.7552C17.472 23.9988 16.8588 23.3856 16.1024 23.3856C15.346 23.3856 14.7328 23.9988 14.7328 24.7552C14.7328 25.5116 15.346 26.1248 16.1024 26.1248Z"
			fill={props.fill}
		/>
		<path
			d="M16.1025 14.9728C15.7281 14.9728 15.4241 15.2768 15.4241 15.6512V18.5984C15.4241 18.9728 15.7281 19.2768 16.1025 19.2768C16.4769 19.2768 16.7809 18.9728 16.7809 18.5984V15.6512C16.7809 15.2768 16.4769 14.9728 16.1025 14.9728Z"
			fill={props.fill}
		/>
		<path
			d="M16.1025 9.20001C15.7281 9.20001 15.4241 9.50401 15.4241 9.87841V12.8256C15.4241 13.2 15.7281 13.504 16.1025 13.504C16.4769 13.504 16.7809 13.2 16.7809 12.8256V9.87841C16.7809 9.50401 16.4769 9.20001 16.1025 9.20001Z"
			fill={props.fill}
		/>
		<path
			d="M14.688 13.5616H11.7408C11.3664 13.5616 11.0624 13.8656 11.0624 14.24C11.0624 14.6144 11.3664 14.9184 11.7408 14.9184H14.688C15.0624 14.9184 15.3664 14.6144 15.3664 14.24C15.3664 13.8656 15.0624 13.5616 14.688 13.5616Z"
			fill={props.fill}
		/>
		<path
			d="M20.4608 13.5616H17.5136C17.1392 13.5616 16.8352 13.8656 16.8352 14.24C16.8352 14.6144 17.1392 14.9184 17.5136 14.9184H20.4608C20.8352 14.9184 21.1392 14.6144 21.1392 14.24C21.1392 13.8656 20.8352 13.5616 20.4608 13.5616Z"
			fill={props.fill}
		/>
	</>
);

export default WellNowVirtualCare;
